module.exports = __webpack_public_path__ + "static/p2-a42cd44dd10145523efc87c0f8b846ac.jpg";